import React from "react";

// Style
import "./FormatOptionLabel.scss";

// Lib
import { sanitize } from "dompurify";
import { decodeHtmlEntity } from "lib/helpers";
import { useAppSelector } from "lib/hooks/useDispatch";

// Link
import { Link } from "react-router-dom";

// Type
import { Supplier } from 'pages/MoleculeProduct/reducer';

// Interface
interface FormatOptionLabelInterface {
  id?: string,
  cas?: string,
  name?: string,
  catNumber?: string,
  supIds?: Supplier[],
  compoundsCount?: number,
}

const FormatOptionLabel: React.FC<FormatOptionLabelInterface> = (props) => {
  const {
    id,
    cas,
    name,
    catNumber,
    compoundsCount
  } = props;
  let content = <></>;

  const type = useAppSelector(
    (store) => store.search?.searchDataKeyBoard?.type
  ) || "compounds";

  switch (type) {
    case "drugs":
    case "compounds":
    case "impurities":
    case "chemicalProbes":
      const compoundsLink = `/molecule-product/${id}`;
      content = <Link
        to={compoundsLink}
        className="format-option-label flex flex-ai-start flex-jc-center flex-direction-column"
      >
        <p className="format-option-label__text">
          <span>ID:</span> {id ? id : "-"}
        </p>
        <p className="format-option-label__text">
          <span>CAS:</span> {cas ? cas : "-"}
        </p>
        <p
          className="format-option-label__text"
          dangerouslySetInnerHTML={{
            __html: sanitize(name ? `<span>Name:</span> ${decodeHtmlEntity(name)}` : "<span>Name:</span> -")
          }}
        />
      </Link>;
      break;

    case "libraries":
      const librariesLink = `/libraries-product/${catNumber}`;
      content = <Link
        to={librariesLink}
        className="format-option-label flex flex-ai-start flex-jc-center flex-direction-column"
      >
        <p className="format-option-label__text">
          {catNumber}
        </p>
        <p className="format-option-label__text">
          <span>Compounds</span> {compoundsCount ? compoundsCount : "-"}
        </p>
        <p
          className="format-option-label__text"
          dangerouslySetInnerHTML={{
            __html: sanitize(name ? `<span>Name:</span> ${decodeHtmlEntity(name)}` : "<span>Name:</span> -")
          }}
        />
      </Link>;
      break;

    default:
      content = <div className="format-option-label">
        Not found template in option
      </div>;
      break;
  }

  return content;
};

export default FormatOptionLabel;
